import { useTranslator } from '@bluebeam/react-i18n';
import RFIFilterPopover from 'components/RFIFilterPopover';
import RFIListSearch from 'pages/RFIPage/RFISubheader/RFIListSearch';
import React from 'react';
import { queryRFIMarkups } from 'utils/queryRFIs';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import SortPopover from './SortPopover';

interface Props extends WithAppStoreProps {
  count: number;
}

const RFIListHeader = (props: Props): React.ReactElement => {
  const { translate } = useTranslator(['mapView']);
  const { appState, count, actions } = props;
  const { rfis, markups, roles, sheets, rfiQuery } = appState;

  const onShowAll = (): void => {
    const updatedQuery = rfiQuery.clear().set('pages', rfiQuery.pages);
    actions.setRFIQuery(updatedQuery);
  };

  const rfiMarkups = queryRFIMarkups(rfis, roles, markups, sheets, rfiQuery);
  const totalRFIMarkups = queryRFIMarkups(
    rfis,
    roles,
    markups,
    sheets,
    rfiQuery.clear().set('pages', rfiQuery.pages)
  );

  const filteredApplied =
    rfiMarkups.size !== totalRFIMarkups.size &&
    rfiQuery.pages !== null &&
    rfiQuery.pages.size > 0;

  return (
    <div className="px4 py3 bb-2">
      <div className="row justify-between mb4">
        <div className="bold">
          {`${translate('mapView:viewMapLayers.allItems')} (${count})`}
        </div>
        <div>
          {filteredApplied ? (
            <div
              className="bold font-size-4 color-primary cursor-pointer"
              onClick={onShowAll}
            >
              {translate('mapView:viewMapLayers.showAll')}
            </div>
          ) : null}
        </div>
      </div>
      <div className="row items-center">
        <div className="grow-1 mr3">
          <RFIListSearch />
        </div>
        <div className="mr3">
          <RFIFilterPopover useCondensed />
        </div>
        <div>
          <SortPopover />
        </div>
      </div>
    </div>
  );
};

export default withAppStore<Props>(RFIListHeader);
